
<template>
  <div class="home">
    <el-container>
       
           <Menu></Menu>
        
        <el-container class="content">
            <Header></Header>
            <el-main>
                <Breadcrumb></Breadcrumb>
                <div class="cont">
                  <router-view></router-view>
                </div>
            </el-main>
        </el-container>
    </el-container>
  </div>
</template>
<script>
 import Header from "@/components/common/Header"
 import Menu from "@/components/common/Menu"
 import Footer from "@/components/common/Footer"
 import Breadcrumb from "@/components/common/Breadcrumb"
 export default {
        name:"layout",
        components:{
            Header,
            Menu,
            Footer,
            Breadcrumb
        },
        data() {
      return {
        editableTabsValue: '1',
        editableTabs: [{
          title: 'Tab 1',
          name: '1',
          content: 'Tab 1 content'
        }, {
          title: 'Tab 2',
          name: '2',
          content: 'Tab 2 content'
        }],
        tabIndex: 2
      }
    },
    methods: {
      addTab(targetName) {
        let newTabName = ++this.tabIndex + '';
        this.editableTabs.push({
          title: 'New Tab',
          name: newTabName,
          content: 'New Tab content'
        });
        this.editableTabsValue = newTabName;
      },
      removeTab(targetName) {
        let tabs = this.editableTabs;
        let activeName = this.editableTabsValue;
        if (activeName === targetName) {
          tabs.forEach((tab, index) => {
            if (tab.name === targetName) {
              let nextTab = tabs[index + 1] || tabs[index - 1];
              if (nextTab) {
                activeName = nextTab.name;
              }
            }
          });
        }
        this.editableTabsValue = activeName;
        this.editableTabs = tabs.filter(tab => tab.name !== targetName);
      }
    }
  }
    
</script>
<style lang="less" scoped>
@background:#B3C0D1;
.home{
width: 100%;
height: 100%;
}
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    bottom: 0;
    margin: 0;
    padding: 0;
    font-size: 18px;
  }
  .content {
    display: flex;
    flex-direction: column;
    width: 100%;
    top: 60px;
    bottom: 0;
    margin-left: 210px;
  }
  
</style>




// WEBPACK FOOTER //
// src/layout/layout.vue